// Port of api/fuel/app/classes/filter/search/games/rules/query/bgg_rank.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'bgg_rank',
	field: function() { return 'g.game_rank' },
	pre: function(rule, config, filter, data, query) {
		query.where('g.game_rank', '>', 0)
	}
})
